import React from "react";
import styled from "styled-components";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import retentionImg from "../assets/Col-1024x792.png";

const RetentionSection = styled.section`
  padding: 8rem 5%;
  background-color: var(--surface);
  position: relative;
`;

const BackgroundBlob = styled.div`
  position: absolute;
  top: 50%;
  right: -10%;
  width: 500px;
  height: 500px;
  background: rgba(255, 85, 0, 0.1);
  filter: blur(120px);
  border-radius: 50%;
  z-index: 0;
  pointer-events: none;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 10;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.div`
  h2 {
    font-size: clamp(2.5rem, 4vw, 3.5rem);
    margin-bottom: 2rem;
    color: var(--text-primary);
    line-height: 1.2;

    span {
      color: var(--secondary);
    }
  }

  p {
    font-size: 1.25rem;
    color: var(--text-secondary);
    margin-bottom: 2rem;
    line-height: 1.6;
  }
`;

const List = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
  color: var(--text-primary);

  svg {
    color: var(--secondary);
    flex-shrink: 0;
  }
`;

const ImageContainer = styled.div`
  img {
    width: 100%;
    border-radius: 1rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  }
`;

export const RetentionTool: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    t("retention.list1"),
    t("retention.list2"),
    t("retention.list3"),
    t("retention.list4"),
    t("retention.list5"),
    t("retention.list6"),
  ];

  return (
    <RetentionSection>
      <BackgroundBlob />
      <Container>
        <Content>
          <h2>
            {t("retention.title_part1")} <br />
            <span>{t("retention.title_part2")}</span>
          </h2>
          <p>{t("retention.description")}</p>
          <List>
            {features.map((feature, index) => (
              <ListItem key={index}>
                <CheckCircle2 size={24} />
                {feature}
              </ListItem>
            ))}
          </List>
        </Content>
        <ImageContainer>
          <img src={retentionImg} alt={t("retention.alt_img")} />
        </ImageContainer>
      </Container>
    </RetentionSection>
  );
};

